import React from 'react';
import { CopyrightText } from '../styles/copyright.style';

/**
 * Copyright Component
 * @param {object} params Incoming Params
 * @returns {XML} A new copyright component
 */
const Copyright = () => <CopyrightText>TM &amp; © 2019 XFL. All rights reserved.</CopyrightText>;

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/copyright/components/copyright.js